module.exports = __webpack_public_path__ + "static/wood1-8a1a25ae57430c8537317e251b474e24.png";